<template>
  <div>
    <div v-if="record.length === 0 && !loading && !firstLoad" class="no-data member-empty" role="status">
      <p>{{ $t('Bao.no_relevant_data_records') }}</p>
      <span>{{ $t('Bao.search_results_are_empty') }}</span>
    </div>

    <!-- 結構同切版 my-bet.html：PC 為 bet-list 表格，手機為 bet-list-mobile 每筆一張 bet-table -->
    <template v-else-if="record.length > 0">
      <div class="bet-list">
        <div class="bet-table">
          <table>
            <tbody>
              <tr>
                <th>{{ $t("Bao.plateform_name") }}<span class="txt-inlineBlock">{{ $t("Bao.game") }}</span></th>
                <th>{{ $t("Bao.game_finish_at") }}</th>
                <th>{{ $t("Bao.bet_amount") }}</th>
                <th>{{ $t('Bao.bet_degree') }}</th>
                <th>{{ $t("Bao.win_amount") }}</th>
                <th>{{ $t("Bao.tran_id") }}</th>
                <th>{{ $t("Bao.status") }}</th>
              </tr>
              <tr v-for="(item, key) in record" :key="key">
                <td>{{ item.game_provider_name }}<span class="txt-inlineBlock">{{ item.game_name }}</span></td>
                <td>{{ item.formattedTime }}</td>
                <td>
                  <div class="betAmount">
                    <span>{{ item.bet_amount | numberFormatExtended }}</span><img class="bet-icon" :src="item.image" alt="">
                  </div>
                </td>
                <td>{{ calculateBetDegree(item.win_amount, item.bet_amount) }}</td>
                <td>
                  <div class="betAmount">
                    <span>{{ item.win_amount | numberFormatExtended }}</span><img class="bet-icon" :src="item.image" alt="">
                  </div>
                </td>
                <td>
                  <div class="bet-id">
                    {{ item.tran_id }}
                  </div>
                </td>
                <td>{{ getStatusText(item.status) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="bet-list-mobile">
        <div v-for="(item, key) in record" :key="key" class="bet-table">
          <table>
            <tbody>
              <tr>
                <td>{{ $t("Bao.plateform_name") }}</td>
                <td class="fs-14-w-700">
                  {{ item.game_provider_name }}
                </td>
              </tr>
              <tr>
                <td>{{ $t("Bao.game") }}</td>
                <td class="fs-14-w-700">
                  {{ item.game_name }}
                </td>
              </tr>
              <tr>
                <td>{{ $t("Bao.game_finish_at") }}</td>
                <td class="fs-14-w-700">
                  {{ item.formattedTime }}
                </td>
              </tr>
              <tr>
                <td>{{ $t("Bao.bet_amount") }}</td>
                <td class="fs-14-w-700">
                  <div class="betAmount">
                    <span>{{ item.bet_amount | numberFormatExtended }}</span><img class="bet-icon" :src="item.image" alt="">
                  </div>
                </td>
              </tr>
              <tr>
                <td>{{ $t('Bao.bet_degree') }}</td>
                <td class="fs-14-w-700">
                  {{ calculateBetDegree(item.win_amount, item.bet_amount) }}
                </td>
              </tr>
              <tr>
                <td>{{ $t("Bao.win_amount") }}</td>
                <td class="fs-14-w-700">
                  <div class="betAmount">
                    <span>{{ item.win_amount | numberFormatExtended }}</span><img class="bet-icon" :src="item.image" alt="">
                  </div>
                </td>
              </tr>
              <tr>
                <td>{{ $t("Bao.tran_id") }}</td>
                <td class="fs-14-w-700">
                  <div class="bet-id">
                    {{ item.tran_id }}
                  </div>
                </td>
              </tr>
              <tr>
                <td>{{ $t("Bao.status") }}</td>
                <td class="fs-14-w-700">
                  {{ getStatusText(item.status) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'BetHistory',
  filters: {
    numberFormatExtended(value) {
      if (!value) return '0'
      // Support up to 8 decimal places
      return parseFloat(value).toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 8
      })
    }
  },
  props: {
    record: {
      type: Array,
      default: () => ([])
    },
    loading: {
      type: Boolean,
      default: false
    },
    firstLoad: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    }
  },
  computed: {
    getStatusText() {
      return (status) => {
        switch (status) {
          case '1':
            return this.$t('Bao.bet_success')
          case '0':
            return this.$t('Bao.bet_pending')
          case '-1':
            return this.$t('Bao.bet_failed')
          default:
            return '-'
        }
      }
    }
  },
  created() {

  },
  methods: {
    calculateBetDegree(winAmount, betAmount) {
      if (!betAmount || parseFloat(betAmount) === 0) return '-'

      const ratio = parseFloat(winAmount) / parseFloat(betAmount)
      return ratio.toFixed(2) + 'x'
    }
  }
}
</script>
